module.exports = __webpack_public_path__ + "img/scene-field.74624c57.jpg";